export default __webpack_public_path__ + "static/media/reimsmini.970f75f6.jpg";